import React, { useEffect, useState } from 'react';
import { Navigate, useLocation } from 'react-router-dom';
import axios from 'axios';

const API = process.env.REACT_APP_BACKEND_URL;

export const ProtectedRoute = ({ children, ownerOnly = false, fullBilling = false }) => {
  const [status, setStatus] = useState('checking');
  const [role, setRole] = useState('owner');
  const location = useLocation();

  useEffect(() => {
    const check = async () => {
      const token = localStorage.getItem('njk_admin_token');
      // 1) Classic JWT login (owner or staff)
      if (token && token !== 'google-session') {
        try {
          const res = await axios.post(`${API}/api/auth/verify`, { token });
          if (res.data.valid) {
            const r = res.data.role || 'owner';
            setRole(r);
            localStorage.setItem('njk_admin_role', r);
            localStorage.setItem('njk_full_billing', res.data.full_billing === false ? 'false' : 'true');
            setStatus('authorized');
            return;
          }
        } catch (e) { /* fall through to Google session check */ }
      }
      // 2) Emergent-managed Google session (httpOnly cookie) — always owner
      try {
        await axios.get(`${API}/api/auth/me`, { withCredentials: true });
        setRole('owner');
        localStorage.setItem('njk_admin_role', 'owner');
        localStorage.setItem('njk_full_billing', 'true');
        setStatus('authorized');
      } catch (e) {
        localStorage.removeItem('njk_admin_token');
        localStorage.removeItem('njk_admin_user');
        localStorage.removeItem('njk_admin_role');
        setStatus('unauthorized');
      }
    };
    check();
  }, [location.pathname]);

  if (status === 'checking') {
    return (
      <div className="min-h-screen flex items-center justify-center">
        <div className="animate-spin rounded-full h-8 w-8 border-b-2 border-blue-600"></div>
      </div>
    );
  }

  if (status === 'unauthorized') {
    return <Navigate to="/admin/login" state={{ from: location }} replace />;
  }

  if (ownerOnly && role === 'staff') {
    return <Navigate to="/admin/billing" replace />;
  }

  if (fullBilling && role === 'staff' && localStorage.getItem('njk_full_billing') === 'false') {
    return <Navigate to="/admin/billing" replace />;
  }

  return children;
};
